<app-form-shell [title]="isEditMode ? 'Editar Configuración de centro de trabajo' : 'Nueva Configuración de centro de trabajo'"
  [mode]="mode" (expand)="expand()" (close)="onCancel()" [actions]="actions">

  <div *ngIf="isLoading" class="loading-overlay">
    <div class="spinner-container">
      <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
      <p class="loading-text">Cargando configuración...</p>
    </div>
  </div>

  <div *ngIf="isSaving" class="saving-overlay">
    <div class="saving-box">
      <div class="saving-header">Guardando configuración</div>
      <div class="saving-body">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
        <p>Por favor espera un momento...</p>
      </div>
    </div>
  </div>

  <mat-card appearance="outlined" *ngIf="!isLoading">
    <div *ngIf="!locationId" class="alert alert-info mb-3 d-flex align-items-center">
      <mat-icon class="me-2">info</mat-icon>
      <span>
        <strong>Información:</strong> Las pestañas de Media, Conceptos y Horarios estarán disponibles
        una vez que guardes los datos generales del centro de trabajo.
      </span>
    </div>

    <mat-tab-group (selectedTabChange)="onTabChange($event)">

      <mat-tab label="Datos generales">
        <div class="tab-content">
          <app-location-general-section
            [formGroup]="form.get('general')"
            [isEditMode]="isEditMode"
            [isSaving]="isSavingGeneral"
            [isLoadingCatalogs]="isLoadingCatalogs"
            [countriesOptions]="countriesOptions"
            [provincesOptions]="provincesOptions"
            [municipalitiesOptions]="municipalitiesOptions"
            [locationStatusesOptions]="locationStatusesOptions"
            [merchantLocationCategoriesOptions]="merchantLocationCategoriesOptions"
            [timeZonesOptions]="timeZonesOptions"
            [currencyCodesOptions]="currencyCodesOptions"
            (save)="onSaveGeneralSection($event)"
            (countryChanged)="onCountryChange($event)"
            (stateChanged)="onStateChange($event)">
          </app-location-general-section>
        </div>
      </mat-tab>

      <mat-tab label="Logo e imágenes" [disabled]="!locationId">
        <div class="tab-content">
          <app-location-media-section [locationId]="locationId">
          </app-location-media-section>
        </div>
      </mat-tab>

      <mat-tab label="Conceptos" [disabled]="!locationId">
        <div class="tab-content">
          <app-location-service-section
            [formGroup]="form.get('services')"
            [locationId]="locationId">
          </app-location-service-section>
        </div>
      </mat-tab>

      <mat-tab label="Personal" [disabled]="!locationId">
        <div class="tab-content">
          <app-location-staff-section
            [formGroup]="form.get('staff')"
            [locationId]="locationId">
          </app-location-staff-section>
        </div>
      </mat-tab>

      <mat-tab label="Horarios" [disabled]="!locationId">
        <div class="tab-content">
          <app-location-availability-section
            [formGroup]="form.get('availability')"
            [locationId]="locationId">
          </app-location-availability-section>
        </div>
      </mat-tab>

      <mat-tab label="Pagos" [disabled]="!locationId">
        <div class="tab-content">
          <app-location-payments-section [locationId]="locationId">
          </app-location-payments-section>
        </div>
      </mat-tab>

      <mat-tab label="Reseñas" [disabled]="!locationId">
        <div class="tab-content">
          <app-location-reviews-section [locationId]="locationId">
          </app-location-reviews-section>
        </div>
      </mat-tab>

      <mat-tab label="Notificaciones" [disabled]="!locationId">
        <div class="tab-content">
          <app-location-notifications-section [locationId]="locationId">
          </app-location-notifications-section>
        </div>
      </mat-tab>

    </mat-tab-group>
  </mat-card>

</app-form-shell>
